import { ArrowRight } from "lucide-react";
import { categories } from "../data/services";
import { useLanguage } from "../i18n/LanguageContext";
import { Reveal } from "./Reveal";

export const CategoryCards = () => {
  const { t, L } = useLanguage();
  return (
    <section className="py-20 sm:py-28" data-testid="categories-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-8">
        <Reveal className="mb-12 sm:mb-16 max-w-xl">
          <p className="text-xs font-semibold tracking-[0.25em] text-[#E85D75] mb-3 uppercase">
            {t.chaptersEyebrow}
          </p>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-stone-900">
            {t.chaptersTitle}
          </h2>
        </Reveal>
        <div className="grid md:grid-cols-3 gap-6 sm:gap-8">
          {categories.map((c, i) => (
            <Reveal key={c.id} delay={i * 0.12}>
              <a
                href={c.target}
                data-testid={`category-card-${c.id}`}
                className="group block relative rounded-3xl overflow-hidden bg-white border border-stone-200 shadow-[0_8px_30px_rgb(0,0,0,0.04)] hover:-translate-y-1.5 hover:shadow-[0_20px_50px_rgb(0,0,0,0.10)] transition-all duration-300"
              >
                <div className="relative h-56 sm:h-64 overflow-hidden">
                  <img
                    src={c.image}
                    alt={c.name}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                  />
                  <span
                    className="absolute top-4 left-4 font-display text-sm font-semibold text-white rounded-full px-3 py-1 backdrop-blur-md bg-black/30"
                  >
                    {String(i + 1).padStart(2, "0")}
                  </span>
                </div>
                <div className="p-6 sm:p-7">
                  <div className="w-10 h-1 rounded-full mb-4" style={{ backgroundColor: c.accent }} />
                  <h3 className="font-display text-2xl sm:text-3xl font-semibold text-stone-900">
                    {L(c, "name")}
                  </h3>
                  <p className="mt-2 text-base text-stone-500 leading-relaxed">{L(c, "tagline")}</p>
                  <span
                    className="mt-5 inline-flex items-center gap-2 text-sm font-semibold"
                    style={{ color: c.accent }}
                  >
                    {t.viewServices}
                    <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform duration-200" />
                  </span>
                </div>
              </a>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
